export const bingoData = [
  {
    id: 'hiking',
    text: 'Debugging finance issue on a hike'
  },
  {
    id: 'wedding',
    text: 'On a Zoom call during a wedding'
  },
  {
    id: 'beach',
    text: 'Deploying to prod from a beach'
  },
  {
    id: 'kids',
    text: 'Kids interrupting a meeting'
  },
  {
    id: 'pets',
    text: 'Pet walks across keyboard'
  },
  {
    id: 'coffee',
    text: 'Spilled coffee on laptop'
  },
  {
    id: 'wifi',
    text: 'WiFi goes out during presentation'
  },
  {
    id: 'pajamas',
    text: 'Coding in pajamas all day'
  },
  {
    id: 'laundry',
    text: 'Doing laundry between meetings'
  },
  {
    id: 'mute',
    text: '"You\'re on mute"'
  },
  {
    id: 'airplane',
    text: 'Working from an airplane'
  },
  {
    id: 'kitchen',
    text: 'Office is now the kitchen'
  },
  {
    id: 'delivery',
    text: 'Doorbell rings during standup'
  },
  {
    id: 'background',
    text: 'Embarrassing Zoom background'
  },
  {
    id: 'car',
    text: 'Taking a call from your car'
  },
  {
    id: 'power',
    text: 'Power outage during deadline'
  },
  {
    id: 'midnight',
    text: 'Deploying at midnight'
  },
  {
    id: 'forest',
    text: 'Coding from a forest'
  },
  {
    id: 'coworker',
    text: 'Haven\'t seen a coworker IRL in 6+ months'
  },
  {
    id: 'vacation',
    text: 'Working on "vacation"'
  },
  {
    id: 'exercise',
    text: 'Standups are now actual stand ups'
  },
  {
    id: 'food',
    text: 'Eating lunch during a meeting'
  },
  {
    id: 'camera',
    text: '"Sorry, my camera isn\'t working"'
  },
  {
    id: 'dressed',
    text: 'Business shirt, pajama pants'
  },
  {
    id: 'hair',
    text: 'Bad hair day = camera off day'
  },
  {
    id: 'hotel',
    text: 'Coding from a hotel lobby'
  },
  {
    id: 'night',
    text: 'Coding at 3am because why not'
  },
  {
    id: 'kids_noise',
    text: 'Muting due to kids/pet noise'
  },
  {
    id: 'mountain',
    text: 'Working from a mountain top'
  },
  {
    id: 'spouse',
    text: 'Spouse walks into frame'
  },
  {
    id: 'slack',
    text: 'Slack message at dinner time'
  },
  {
    id: 'forgot',
    text: 'Forgot about a meeting'
  },
  {
    id: 'backyard',
    text: 'Working from the backyard'
  },
  {
    id: 'bathroom',
    text: 'Accidentally took device to bathroom'
  },
  {
    id: 'noise',
    text: 'Construction noise during call'
  },
  {
    id: 'neighbor',
    text: 'Neighbor mowing lawn during presentation'
  }
]